import { Image } from 'components/Image'
import classNames from 'classnames'
import { Typography } from 'components/Typography'

const Item = ({ iconSrc, html, className }) => (
  <div
    className={classNames(
      'flex w-full flex-row items-center gap-8',
      'xl:w-auto xl:max-w-none xl:shrink-0 xl:gap-2',
      className
    )}
  >
    <div className="flex h-9 w-[37px] shrink-0 items-center justify-center">
      <Image
        src={iconSrc}
        alt=""
        className="h-9 max-h-9 w-[37px] max-w-[37px] object-contain object-center"
        width={37}
        height={36}
      />
    </div>
    <Typography
      variant="bodySm"
      component="p"
      className={classNames(
        'min-w-0 flex-1 text-left text-sm font-normal leading-[1.4] text-[#154199]',
        'xl:flex-none xl:whitespace-nowrap xl:text-center',
        '[&_b]:font-bold [&_span]:text-[#154199]'
      )}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  </div>
)

const LoginTrustStrip = ({ iconStrip }) => {
  const { clients, noRisk, debtResolved } = iconStrip

  return (
    <div
      className="w-full min-w-0 rounded-[8px] bg-[#EEF3FC] p-4"
      data-testid="client-dashboard-login-trust-strip"
    >
      <div
        className={classNames(
          'mx-auto flex w-full min-w-0 max-w-[327px] flex-col gap-4',
          'xl:max-w-none xl:flex-row xl:flex-nowrap xl:items-center xl:justify-center xl:gap-6'
        )}
      >
        <Item iconSrc="/client-dashboard-login/trust-clients.svg" html={clients} />
        <Item iconSrc="/client-dashboard-login/trust-dollar.svg" html={noRisk} />
        <Item iconSrc="/client-dashboard-login/trust-checkmark.svg" html={debtResolved} />
      </div>
    </div>
  )
}

export default LoginTrustStrip
